import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AtMentionUsersList from './AtMentionUsersList';
import t from '../../i18n/I18n';
import './Comments.css';

export default class AtMentionUserNotification extends Component {
  constructor() {
    super();
    this.state = {
      isHovering: false
    };
    this.handleMouseOver = this.handleMouseOver.bind(this);
  }

  handleMouseOver() {
    this.setState(this.toggleHoverState);
  }

  toggleHoverState(state) {
    return {
      isHovering: !state.isHovering,
    };
  }

  render() {
    const {atMentions} = this.props;
    if (atMentions.length) {
      const bottomPos = `${20 + 40 * atMentions.length}px`;
      const peopleLabel = atMentions.length === 1 ? 'person' : 'people';
      return (
        <div className="notified-users">
          {this.state.isHovering && <div style={{ position: 'absolute', bottom: bottomPos}}><AtMentionUsersList users={atMentions} /></div>}
          <h6><span className="users-list" onMouseEnter={this.handleMouseOver} onMouseLeave={this.handleMouseOver}>{atMentions.length} {peopleLabel}</span> {t('MENTIONED')}</h6>
        </div>
      );
    }
    return null;
  }
}

AtMentionUserNotification.propTypes = {
  atMentions: PropTypes.array.isRequired
};